"use strict";

export default class Drivers {
  constructor($q, API) {
    this.$q = $q;
    this.API = API;
  }

  getDrivers(groupIds, searchTerm, paging, targetAccount = null) {
    let deferred = this.$q.defer();
    let url = "v1/drivers";

    let param = [];
    param.push.apply(param, this.API.getPagingQuery(paging));
    param.push.apply(param, this.API.getArrayQuery("includeGroupId", groupIds));
    if (searchTerm) param.push("searchTerm=" + searchTerm);

    if (targetAccount !== null)
      param.push("targetAccount=" + targetAccount);

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((drivers) => {
        //console.log("drivers: ", drivers);
        deferred.resolve(drivers);

      })
      .error((err) => {
        console.log("error: ", err);
        deferred.reject(err);
      });

    return deferred.promise;
  }
}

Drivers.$inject = ["$q", "FleetPortalAPI"];



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-fleetlink/fleetlink.drivers.js